export * from './lab-view-attachment.component';

